<template>
  <div class="ls_spin_container">
    <Row>

      <Col :xl="21">
        <Row :gutter="24" class="store__container">
          <Col :xl='8' :xxl="6" v-for="el of data" :key="el.id" style="margin-bottom: 24px">

            <div class="card-shop">

              <img v-if="el.image_url" :src="imgUrl + el.image_url" alt="" class="shop-img">
              <img v-else src="/static/img/store.png" alt="" class="shop-img">

              <Card class="card-container">


                <div class="mb-15 card_header">
                  <h2 @click="$router.push({name: item_type+ '_detail', params: {id: el.id}})" class="cursor-pointer">
                    {{ el.name }}
                  </h2>

                  <div style="text-align: right">
                    <Tag v-show="el.default" color="success">По-умолчанию</Tag>
                    <Tag v-show="el.deleted_date" color="error">Удален</Tag>
                  </div>

                </div>


                <p class="color-grey fs-15 mb-15">
                  Создан
                  {{ formatDateTime(el.created_date) }}
                </p>

                <div class="mb-15">
                  <p v-if="el.address" class="color-grey fs-15 mb-5">
                    <Icon type="ios-pin-outline"/>
                    {{ el.address }}
                  </p>
                  <p v-if="el.description" class="color-grey fs-15">
                    <Icon type="ios-information-circle-outline"/>
                    {{ el.description }}
                  </p>
                </div>


                <Row class="item_actions" type="flex" justify="space-between">
                  <Button v-if="display_delete_button_by_item(el)" @click="removeModal = true, removeId = el.id"
                          style="color: #EF6E57; border: none; box-shadow: none; padding: 0">
                    <Icon type="md-trash" size="24"/>
                  </Button>
                  <Button
                    v-if="display_edit_button_by_item(el)"
                    style="border-radius: 50%; width: 48px; height: 48px; padding: 0; display: flex; align-items: center; justify-content: center"
                    type="info"
                    @click="$router.push({name: item_type + '_edit', params: {id: el.id}})">
                    <Icon type="md-create" size="24"/>
                  </Button>

                </Row>

              </Card>
            </div>

          </Col>
        </Row>
      </Col>


      <Col :xl="3" align="right">
        <Button v-if="display_create_button" type="info" class="ls_create_button" :to="{ name: item_type + '_create' }"
        >Создать
          <Icon type="ios-create-outline"/>
        </Button>
      </Col>
    </Row>


    <storeItem
      :id="item.id"
      :action="item.action"
      v-model="item.show"
      @reload-table="fetchItems"
      :base_view_url="baseViewUrl"
      :item_type="item_type"
    ></storeItem>



    <!--Modal for remove Item-->
    <Modal
      :footer-hide="footerHide"
      v-model="removeModal"
      title="">

      <h3 class="mb-40">Вы действительно хотите удалить данный магазин?</h3>

      <Row type="flex" justify="center">
        <Button type="error" @click="removeModal = false">Отмена</Button>
        <Button type="success" style="margin-left: 12px"
                @click="deleteItem(removeId)">
          Удалить
        </Button>
      </Row>
    </Modal>


    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
    import {base_url, server_addr} from "../../http.js";
    import storeItem from "@/apps/store/storeItem.vue";
    import cardColumn from "@/components/core/cardColumn.vue";
    import {BaseCardListData} from "../../base/base_card_list.js";

    let _app = BaseCardListData();
    _app.components = {
        storeItem,
        cardColumn
    };

    _app.data = function () {
        return {
            // Base settings
            baseViewUrl: base_url + "/stores/",
            item_type: "store",
            loading: true,

            imgUrl: server_addr,

            data: [],
            item_image_url: "./static/img/shop_v2_80x80.png",


            item: {
                show: false,
                id: null,
                action: null
            },

            removeModal: false,
            removeId: null,
            footerHide: true,
        };
    };



    export default _app;
</script>

<style scoped>
  .card-shop {
    position: relative;
    overflow: hidden;
    min-height: 350px;
    border-radius: 25px;
    padding: 10px;
    display: flex;
    align-items: flex-end;
    /*background: url("/static/img/shop-background.png");*/
    background-size: cover;
  }

  .card-shop .card-container {
    width: 100%;
    position: relative;
    z-index: 3;
  }

  .card-shop .shop-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    object-fit: cover;
    border-radius: 25px;
  }

  .card-shop .card_header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .card-shop .card_header .ivu-tag {
    padding: 0;
  }

  @media screen and (max-width: 1200px) {
    .card-shop {
      min-height: 300px;
    }
    .store__container {
      overflow-x: scroll;
      white-space: nowrap;
      display: flex;
    }

    .store__container .ivu-col {
      width: 250px;
    }
  }


  @media screen and (max-width: 575px) {
    .store__container .ivu-col {
      width: 200px;
    }

    .card-shop p {
      font-size: 10px;
    }

    .ls_create_button {
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/apps/store/store.vue